import { isNil } from 'lodash'
import type { Patch, FieldConfig } from '../types'
import { PatchType } from '../types'
import {
  validateFieldKey,
  validateFieldType,
  validateOptionalFieldType,
  validateConfigType,
  validateConfigProperties,
} from '../validation/validators'

const addField = (fieldKey: string, config: FieldConfig): Patch => {
  validateFieldKey(fieldKey)
  validateConfigType(config)
  validateFieldType(config.type)
  validateConfigProperties(config)
  return {
    op: PatchType.ADD,
    path: `/fields/${fieldKey}`,
    value: config,
  }
}

const updateField = (fieldKey: string, config: FieldConfig): Patch[] => {
  validateFieldKey(fieldKey)
  validateConfigType(config)
  validateOptionalFieldType(config.type)
  validateConfigProperties(config)
  return Object.entries(config).map(([key, value]) => {
    return isNil(value)
      ? {
          op: PatchType.REMOVE,
          path: `/fields/${fieldKey}/${key}`,
        }
      : {
          op: PatchType.ADD,
          path: `/fields/${fieldKey}/${key}`,
          value,
        }
  })
}

const markFieldDeleted = (fieldKey: string): Patch => {
  validateFieldKey(fieldKey)
  return {
    op: PatchType.ADD,
    path: `/fields/${fieldKey}/isDeleted`,
    value: true,
  }
}

const restoreField = (fieldKey: string): Patch => {
  validateFieldKey(fieldKey)
  return {
    op: PatchType.ADD,
    path: `/fields/${fieldKey}/isDeleted`,
    value: false,
  }
}

const deleteFieldPermanently = (fieldKey: string): Patch => {
  validateFieldKey(fieldKey)
  return {
    op: PatchType.REMOVE,
    path: `/fields/${fieldKey}`,
  }
}

export {
  addField,
  updateField,
  markFieldDeleted,
  restoreField,
  deleteFieldPermanently,
}
